module.exports = __webpack_public_path__ + "img/visible-dim-signin.1eeec820.svg";